import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import Parte1A from "./Sezioni/Parte1A";
import Parte1B from "./Sezioni/Parte1B";
import Parte1C from "./Sezioni/Parte1C";
import Parte2 from "./Sezioni/Parte2";
import Parte3 from "./Sezioni/Parte3";
import Utils from "../../../../utils/Utils";
import history from "../../../../utils/History";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import toasterConfig from "../../../../config/toasterConfig";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../utils/Ruoli.json";
import TableAllegati from "../../../../components/tableAllegati/TableAllegati";
import { format } from "date-fns";
import {element} from "prop-types";

class SchedaSpecialeTrattamentoTbc extends Component {

    state = {
        correttezzaStep: {
            parte1A: [],
            parte1B: false,
            parte1C: false,
            parte2: false,
            parte3: false
        },
        validateTBC: {},
        oggettoBE: {},
        corretto: [],
        filesCaricati: [],
        filesDaCaricare: []
    }

    constructor(props) {
        super(props);
        this.createOggettoBeAndcontrolloCorrettezza = this.createOggettoBeAndcontrolloCorrettezza.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.pulisciOggettoBE = this.pulisciOggettoBE.bind(this)
        this._back = this._back.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.uploadAllegati = this.uploadAllegati.bind(this);
        this.updateFiles = this.updateFiles.bind(this);
        this.setStatePadre = this.setStatePadre.bind(this)
        this.obbligatorietaToaster = this.obbligatorietaToaster.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        ToasterSingleton.instance().sottoscrizione(this)
        this.callToGetAllegati();
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
    }

    aggiungiToaster(type,text, textList) {

        ToasterSingleton.instance().aggiuntaToaster(
            {
                type: type,
                text: text,
                timestamp: Date.now(),
                textList: textList
            });
    }

    createOggettoBeAndcontrolloCorrettezza(nameObject, object, corretto, validateTBC) {
        let oggettoBe = this.state.oggettoBE
        oggettoBe[nameObject] = object
        let correttezzaStep = this.state.correttezzaStep
        correttezzaStep[nameObject] = corretto
        let validate = this.state.validateTBC
        validate[nameObject] = validateTBC

        if (object && corretto && validateTBC) {
            this.setState({correttezzaStep: correttezzaStep, oggettoBe: oggettoBe, validateTBC: validate})
        } else if (!corretto && object && validateTBC) {
            this.setState({oggettoBe: oggettoBe, validateTBC: validate})
        } else if (corretto && !object && validateTBC) {
            this.setState({correttezzaStep: correttezzaStep, validateTBC: validate})
        } else if (corretto && object && !validateTBC) {
            this.setState({oggettoBe: oggettoBe, correttezzaStep: correttezzaStep})
        } else if (corretto && !object && !validateTBC) {
            this.setState({correttezzaStep: correttezzaStep})
        } else if (!corretto && object && !validateTBC) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!corretto && !object && validateTBC) {
            this.setState({validateTBC: validate})
        }
        this.controlloCorrettezza()
    }

    pulisciOggettoBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.oggettoBE))
        Utils.removeEmptyValueFromObject(oggettoBE)
        return oggettoBE
    }

    controlloCorrettezza() {
        let correttezzaStep = this.state.correttezzaStep
        let textList = []

        if(correttezzaStep.parte1A && correttezzaStep.parte1A.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.parte1A))
        }
        if(correttezzaStep.parte1B && correttezzaStep.parte1B.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.parte1B))
        }
        if(correttezzaStep.parte1C && correttezzaStep.parte1C.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.parte1C))
        }
        if(correttezzaStep.parte2 && correttezzaStep.parte2.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.parte2))
        }
        if(correttezzaStep.parte3 && correttezzaStep.parte3.length > 0 ){
            textList = textList.concat(Utils.eliminaNullArray(correttezzaStep.parte3))
        }

        return this.setState({corretto: textList})

    }

    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({pathname: path});
    }


    goToHome() {
        let path = "/ricercaSegnalazioni";
        history.push({
            pathname: path
        })
    }

    async validate(clickSalvaOConferma) {

        let validate = this.state.validateTBC

        for (let key in validate) {
            if (validate[key]) {
                return this.aggiungiToaster(toasterConfig.types.critical,validate[key])
            }
        }

        this.props.segnalazione["esitoTbcPolmonare"] = Utils.removeEmptyValueFromObject(this.state.oggettoBE)
        this.props.segnalazione["files"] = await Utils.getFiles(this.state.filesCaricati,this.state.filesDaCaricare);

        let jsonInsert = this.props.segnalazione
        if (clickSalvaOConferma === 1) {
            this.callToPutSegnalazione(jsonInsert);
        } else {
            this.callToConfermaDati(jsonInsert);
        }

    }

    callToPutSegnalazione(jsonInsert) {
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner,this.updateFiles)
    }


    callToConfermaDati(jsonInsert) {
        // let jsonEsitoTbcPolmonare = {esitoTbcPolmonare: this.props.segnalazione.esitoTbcPolmonare};

        SegnalazioniService.postConfermaSchedaSpecialeTbcpolmonare(this.props.segnalazione.idSegnalazione, jsonInsert)
            .then((data) => {
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    this.goToHome()
                }
            })
            .catch(() => {
                this.props.showSpinner(false);
            })
    }



    async uploadAllegati(event) {
        this.props.showSpinner(true);
        let files = event.target.files;
        let pesoTotale = 0
        for (let key in files) {
            if (key !== "item" && key !== "length") {
                pesoTotale = pesoTotale + files[key].size
            }
        }
        if (files && files.length) {
            let oldFiles = this.state.filesDaCaricare;

            if (files.length + oldFiles.length > 5) {
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_LIMIT_CARICAMENTOFILE"]);
            } else  if(pesoTotale > 1000000){
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_LIMIT_DIMENSIONEFILE"]);
            }else {
                let arrayFiles = Array.from(files);

                let result = arrayFiles.filter(file => {
                    return file.type !== "application/pdf";
                });

                if (result.length) {
                    this.props.showSpinner(false);
                    this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_CARICAMENTOFILE"]);
                } else {

                    for (const file of arrayFiles) {
                        file.nome = file.name;
                        file.stato = "inserimento";
                        file.checked = true;
                        file.data = format(new Date(), 'dd/MM/yyyy');
                    }

                    if (oldFiles.length) {

                        for (const file of arrayFiles) {
                            oldFiles.push(file);
                        }

                        await this.setState({filesDaCaricare: oldFiles});
                        localStorage.setItem("scroll", "false");
                    } else {
                        await this.setState({filesDaCaricare: arrayFiles});
                        localStorage.setItem("scroll", "false");
                    }

                    this.props.showSpinner(false);
                }
            }
        } else this.props.showSpinner(false);

    }

    callToGetAllegati() {
        let state = this.state
        if (this.props.segnalazioneCopia.idSegnalazione) {
            SegnalazioniService.getAllegati(this.props.segnalazioneCopia.idSegnalazione).then(res => {
                if(res.data.length > 0){
                    state.filesCaricati = res.data;
                    let idPdf = []
                    state.filesCaricati.forEach(file => {
                        file.checked = true
                        idPdf.push(file.id)
                    });
                    this.props.segnalazioneCopia.idPdf = idPdf
                    this.setState(state);
                    this.controlloCorrettezza();
                }
            }).catch(error => {
                console.log(error);
            });
        } else {
            this.setState(state);
        }
    }

    updateFiles(files) {
        if (files && files.length) {
            files.forEach(element => element.checked = true);
            this.setState({filesDaCaricare: [], filesCaricati: files});
        } else {
            this.setState({filesDaCaricare: [], filesCaricati: []});
        }
    }

    setStatePadre(state){
        this.setState(state)
    }

    obbligatorietaToaster(tipo){
        let textList = this.state.corretto

        if(textList && textList.length > 0 && tipo === "1") return this.aggiungiToaster(toasterConfig.types.confirm, textList, true)
        else if(textList && textList.length > 0 && tipo === "2" && this.props.segnalazioneCopia.stepConfermati && this.props.segnalazioneCopia.stepConfermati.esitoTbcPolmonareConfermato) return this.aggiungiToaster(toasterConfig.types.confirm, textList, true)
        else{
            if(tipo === "1"){
                if((this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)){
                    this.goToHome()
                }
                else this.validate(0)
            }
            else if(tipo === "2") this.validate(1)
        }

    }

    render() {

        const buttonDiv = (

            <ButtonRow
                migrazione={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) ? this.props.segnalazioneCopia.migrazione : false}
                onClickConfermaEProsegui={() => this.obbligatorietaToaster("1")}
                modalTextConferma={"Si vuole procedere con la chiusura della scheda di sorveglianza dell’esito del trattamento nella tbc polmonare. Confermare?"}
                isArchiviato={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                onClickSalva={() => this.obbligatorietaToaster("2")}
                back={this._back}
                allegati={true}
                onClickAllegati={this.uploadAllegati}
                disabledCaricaAllegati={this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                nextStep={false}
            />
        )

        return (<div
                className={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                {ToasterSingleton.instance().renderToaster()}
                <fieldset
                    disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>

                    <Parte1A createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                             datiPaziente={this.props.datiPaziente}
                             segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>

                    <Parte1B createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                             segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>

                    <Parte1C createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                             segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>

                    <Parte2 createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>

                    <Parte3 createOggettoBeAndcontrolloCorrettezza={this.createOggettoBeAndcontrolloCorrettezza}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>

                </fieldset>
                {SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione
                    ? null
                    : <TableAllegati
                        filesCaricati={this.state.filesCaricati}
                        filesDaCaricare={this.state.filesDaCaricare}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        showSpinner={this.props.showSpinner}
                        setStatePadre={this.setStatePadre}
                        disabledCheckBox={this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                    />
                }
                {buttonDiv}
            </div>
        )
    }

}

export default withTranslation('common')(SchedaSpecialeTrattamentoTbc)
